import React from "react";

const reasons = [
  {
    title: "Exceptional Quality",
    description:
      "Pepli is simple to use but does not compromise on quality. Our platform is built to help you focus on what matters most—your creativity.",
  },
  {
    title: "Expertise and Knowledge",
    description:
      "Our team understands the challenges artists face, and we’ve designed Pepli to address those needs, making it the ultimate tool for creatives.",
  },
  {
    title: "User-friendly Experience",
    description:
      "Designed to be intuitive and easy to navigate, Pepli delivers a user-friendly, efficient app designed to make networking, collaboration, and audience-building seamless and effective.",
  },
  {
    title: "The Same Expertise You’d Expect",
    description:
      "Just like how Pepli brings exceptional knowledge to the creative community, we’ve spent hundreds of hours refining the platform to ensure it meets the real-world needs of artists, performers, and creatives.",
  },
  {
    title: "Get Started & Live Creatively",
    description:
      "Set up your profile, upload your portfolio, and connect with the community—all at no extra cost.",
  },
];

const WhyChoosePepli = () => {
  return (
    <section id="about-us" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-[#30D5C8] text-center mb-12">
          Why Choose Pepli?
        </h2>
        <div className="flex justify-center">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-3xl w-full">
            {reasons.map((reason, index) => (
              <div key={index} className="mb-6 last:mb-0">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {index + 1}. {reason.title}
                </h3>
                <p className="text-gray-600">{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoosePepli;
